import React, { useEffect } from 'react';
import { mapValues, } from 'lodash';

import Field from '../Field';
import useFormState from '../hooks/useFormState';

const { entries, } = Object;

export default function ShippingItemForm (props) {
  const { fields, values, onChange, } = props;
  const statedFields = useFormState(values, fields, values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value)]);

  return (
    <div>
      <div className="d-flex flex-wrap">
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <div className="mr-2" style={{ minWidth: 200 }}>
              <Field
                key={fieldName}
                name={fieldName}
                {...fieldSetting}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
}
